import { Injectable, isDevMode } from '@angular/core';
import { Subject } from 'rxjs';
import { map, tap } from 'rxjs/internal/operators';
import { UserStorageService } from '../../../services/user-storage-service/user-storage.service';
import { MultimediaManagerDaoService } from '../multimedia-manager-daos/multimedia-manager-dao.service';
import { MultimediaManagerDialogItem } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';
import { ParserService } from '../parser.service';

@Injectable({
  providedIn: 'root'
})
export class MultimediaManagerDialogUploaderService {

  private listener_percent = new Subject();
  private listener_finished = new Subject();

  constructor(private userStorageService: UserStorageService,
              private parserService: ParserService,
              private multimediaManagerDaoService: MultimediaManagerDaoService) { }

  public saveElement(element) {
    return this.multimediaManagerDaoService.saveElement(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), element.data, element.name, element.type, element.destinyFolderId).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        const item = Object.assign(new MultimediaManagerDialogItem(), this.parserService.parseItem(res['data']['element']));
        return item;
      })
    );
  }

  public updateElement(internalId, element) {
    return this.multimediaManagerDaoService.updateElement(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, element.data, element.name, element.type).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        const item = Object.assign(new MultimediaManagerDialogItem(), this.parserService.parseItem(res['data']['element']));
        return item;
      })
    );
  }

  public deleteElement(elementArray) {
    return this.multimediaManagerDaoService.deleteItem(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), elementArray).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        return res['data'];
      })
    );
  }

  public askPermissionToUpload(originalFileName, fileType, fileSize, destinyFolderId) {
    return this.multimediaManagerDaoService.askPermissionToUpload(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), originalFileName, fileType,  fileSize, destinyFolderId).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        return res['data']['guid'];
      })
    );
  }

  public percent(percent) {
    this.listener_percent.next(percent);
  }

  public listen_percent() {
    return this.listener_percent.asObservable();
  }

  public finished(data) {
    this.listener_finished.next(data);
  }

  public listen_finished() {
    return this.listener_finished.asObservable();
  }
}
